import {
  fetchTemplateForEditor,
  resetEditor,
  selectActiveTemplate,
  selectError,
  selectIsLoaded,
  selectIsLoading,
} from 'modules/manager/store';
import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';

export interface UseLoadTemplateResult {
  templateId: number | null;
  isLoading: boolean;
  isLoaded: boolean;
  error: string | null;
  activeTemplate: ReturnType<typeof selectActiveTemplate>;
  /** Повторить загрузку — кнопка «Повторить» в ветке ошибки редактора. */
  reload: () => void;
}

export function useLoadTemplate(): UseLoadTemplateResult {
  const dispatch = useAppDispatch();
  const { templateId: templateIdParam } = useParams<{ templateId: string }>();

  const templateId = parseId(templateIdParam);

  const isLoading = useAppSelector(selectIsLoading);
  const isLoaded = useAppSelector(selectIsLoaded);
  const error = useAppSelector(selectError);
  const activeTemplate = useAppSelector(selectActiveTemplate);

  const reload = useCallback(() => {
    if (templateId === null) return;
    dispatch(fetchTemplateForEditor({ templateId }));
  }, [dispatch, templateId]);

  useEffect(reload, [reload]);

  useEffect(() => {
    return () => {
      dispatch(resetEditor());
    };
  }, [dispatch]);

  return { templateId, isLoading, isLoaded, error, activeTemplate, reload };
}

function parseId(raw: string | undefined): number | null {
  if (!raw) return null;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}
